export function getFeatureEnabled (name) {
  const localStorageKey = `morpheus-feature-${name}`;
  return localStorage.getItem(localStorageKey) === "1";
}

export function setFeatureState (name, value) {
  const localStorageKey = `morpheus-feature-${name}`;
  const localStorageValue = localStorage.getItem(localStorageKey);
  const val = value ? "1" : "0";
  if (localStorageValue !== val) {
    localStorage.setItem(localStorageKey, val);
  }
}
